import {
  GetOrderDetailsQuery,
  StartPickingOrderMutation,
} from "flows/Picking/queries/order/order.generated";
import { isNullOrUndefined } from "utils/tsHelpers";

import { Order, OrderDetails, OrderWithItems, PickingState } from "./types";
import { serializeItem } from "../item/serializer";

export function serializeStartPickingOrderResponse(
  orderDetails: NonNullable<StartPickingOrderMutation["startPickingOrder"]["orderDetails"]>,
): OrderWithItems {
  const {
    deliveryTag = null,
    externalDeliveryProvider = null,
    handoverIdentifier = null,
  } = orderDetails;
  if (isNullOrUndefined(orderDetails.id)) {
    throw new Error("Order doesn't exist");
  }
  return {
    id: orderDetails.id,
    createdAt: orderDetails.createdAt ?? null,
    isClickAndCollect: orderDetails.isClickAndCollect,
    number: orderDetails.number ?? null,
    state: orderDetails.state ?? null,
    isNewCustomer: orderDetails.isNewCustomer,
    reseller: orderDetails.reseller as Order["reseller"],
    externalDeliveryProvider:
      (externalDeliveryProvider as Order["externalDeliveryProvider"]) || null,
    handoverIdentifier: handoverIdentifier ?? null,
    isInStore: orderDetails.isInStore,
    ageVerification: (orderDetails.ageVerification as Order["ageVerification"]) ?? "NONE",
    weight: orderDetails.weight,
    numberOfItems: orderDetails.pickingItemCount,
    deliveryTag: deliveryTag as Order["deliveryTag"],
    items: orderDetails.items.flatMap((item) => (item ? [serializeItem(item)] : [])),
  };
}

export function serializeOrderDetails(
  response: GetOrderDetailsQuery["getOrderDetails"],
): OrderDetails {
  const {
    pickingDetails = null,
    deliveryTag = null,
    externalDeliveryProvider = null,
    handoverIdentifier = null,
  } = response;
  if (isNullOrUndefined(response.id)) {
    throw new Error("Order doesn't exist");
  }
  const pickingState = pickingDetails?.pickingState ?? null;
  const startedBy = pickingDetails?.startedBy ?? null;
  const finishedBy = pickingDetails?.finishedBy ?? null;
  const handoverContainerIds = pickingDetails?.handoverDetails?.containerIds ?? [];
  const handoverShelfNumbers = pickingDetails?.handoverDetails?.shelfNumbers ?? [];
  return {
    id: response.id,
    createdAt: response.createdAt ?? null,
    isClickAndCollect: response.isClickAndCollect,
    number: response.number ?? null,
    state: response.state ?? null,
    isNewCustomer: response.isNewCustomer,
    reseller: response.reseller as Order["reseller"],
    externalDeliveryProvider:
      (externalDeliveryProvider as Order["externalDeliveryProvider"]) || null,
    handoverIdentifier: handoverIdentifier ?? null,
    isInStore: response.isInStore,
    ageVerification: (response.ageVerification as Order["ageVerification"]) ?? "NONE",
    weight: response.weight,
    numberOfItems: response.pickingItemCount,
    deliveryTag: deliveryTag as Order["deliveryTag"],
    pickingState: (pickingState as PickingState) ?? null,
    startedBy: startedBy?.id
      ? {
          id: startedBy.id,
          displayName: startedBy.displayName ?? null,
        }
      : null,
    finishedBy: finishedBy?.id
      ? {
          id: finishedBy.id,
          displayName: finishedBy.displayName ?? null,
        }
      : null,
    handoverContainerIds: handoverContainerIds ?? [],
    handoverShelfNumbers: handoverShelfNumbers ?? [],
  };
}
